<style src="./OutdatedRegister.scss" lang="scss"></style>
<template>
 <section class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-md-3">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form class="form-horizontal" @submit.prevent="registerForm">
              <h2>Cadastro</h2>
              <p>Cadastro manual de entrada de crédito e estacionamento</p>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="col-md-12">Colaborador</label>
                    <div class="col-md-12">
                      <select class="form-control" v-model="form.employee">
                        <option value>Todos</option>
                        <option
                        v-for="(item, idx) in employeeList"
                        :key="idx"
                        :value="item.userToken">
                        {{ item.fullName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="col-md-12">Estacionamento</label>
                    <div class="col-md-12">
                      <select class="form-control" v-model="form.parking">
                        <option value>Todos</option>
                        <option
                        v-for="(item, idx) in parkingList"
                        :key="idx"
                        :value="item.id">
                        {{ item.parkName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 col-xl-6">
                  <div class="form-group">
                    <label class="col-md-12">Data</label>
                    <div class="col-md-12">
                      <input
                        type="date"
                        class="form-control"
                        v-model="form.date">
                    </div>
                  </div>
                  <h6 class="text-danger m-b-lg" v-show="disableSubimitWHenDate">Só será permitido data inferior a 20/07/2019</h6>
                </div>

                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label class="col-md-12">Hora</label>
                    <div class="col-md-12">
                      <input
                        ref="inputTime"
                        type="text"
                        class="form-control"
                        v-mask="'##:##:##'"
                        placeholder="HH:MM:SS"
                        @focus="selectFocus('inputTime')"
                        v-model="form.time">
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label class="col-md-12">Placa</label>
                    <div class="col-md-12">
                      <input
                        ref="inputLicencePlate"
                        type="text"
                        class="form-control"
                        @focus="selectFocus('inputLicencePlate')"
                        v-model="form.licencePlate">
                    </div>
                  </div>
                </div>
              
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label class="col-md-12">Valor</label>
                    <div class="col-md-12">
                      <input
                        ref="inputAmountPaid"
                        type="text"
                        class="form-control"
                        v-money="money"
                        @focus="selectFocus('inputAmountPaid')"
                        v-model.lazy="form.amountPaid">
                    </div>
                  </div>
                </div>

                <div class="col-md-4 col-sm-4">
                  <div class="form-group">
                    <label class="col-md-12">Minutos</label>
                    <div class="col-md-12">
                      <input
                        ref="inputTotalMinutes"
                        type="text"
                        class="form-control"
                        @focus="selectFocus('inputTotalMinutes')"
                        v-model="form.totalMinutes">
                    </div>
                  </div>
                </div>

                
              </div>

              <div class="row">
                <div class="col-md-2 pull-right">
                  <button
                    class="btn btn-lg btn-primary pull-right btn-submit"
                    :disabled="formControl.disabledSubmit"
                    type="submit">
                    <i class="fa fa-save"></i>
                    Cadastrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-md-9 animated fadeInRight">
        <div class="mail-box-header">
          <form 
            v-on:submit.prevent="filterReport"
            class="pull-right mail-search">
            <div class="input-group">
              <input
                type="text"
                class="form-control input-md"
                v-model="filterForm.startDate"
                v-mask="'##/##/####'"
                placeholder="Data">

              <div class="input-group-btn">
                <button type="submit" class="btn btn-sm btn-primary">
                  <i class="fa fa-search"></i>
                  Filtrar 
                </button>
              </div>
            </div>
          </form>
            
          <h2>Lista de Créditos</h2>
            
          <div class="mail-tools tooltip-demo m-t-md">
            <div class="btn-group pull-right">
              <button
                class="btn btn-white btn-sm"
                @click="firstPage()">
                <i class="fa fa-fast-backward"></i>
              </button>
              <button
                class="btn btn-white btn-sm"
                @click="previousPage()">
                <i class="fa fa-arrow-left"></i>
              </button>
              <span class="btn">{{ (filterForm.pageSkip / filterForm.pageLimit) + 1 }} de {{ Math.ceil(filterForm.countPages / filterForm.pageLimit) }}</span>            
              <button
                class="btn btn-white btn-sm"
                @click="nextPage()">
                <i class="fa fa-arrow-right"></i>
              </button>
              <button
                class="btn btn-white btn-sm"
                @click="lastPage()">
                <i class="fa fa-fast-forward"></i>
              </button>
            </div>
            
            <div class="total-amount-paid pull-right btn-sm">
              Valor Total da Busca: <strong>R$ {{ this.resultList.totalAmountPaid | totalToCurrencyBR }}</strong>
            </div>
            
            <div class="clearfix"></div>
          </div>

          <div class="hr-line-dashed"></div>
        </div>
        
        <div class="mail-box ibox-content">
          <table class="table table-hover table-mail">
            <thead>
              <th>Placa</th>
              <th>Colaborador</th>
              <th>Data</th>
              <th>Hora</th>
              <th>Valor</th>
              <th>Minutos</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in resultList.list"
                :key="idx"
                :class="{ 'unread': item.settled }">

                <td>{{ item.licencePlate }}</td>
                <td>{{ item.employeeName }}</td>
                <td>{{ item.startDate | fillDate }}</td>
                <td>{{ item.startDate | fillTime }}</td>
                <td>{{ item.amountPaid | totalToCurrencyBR }}</td>
                <td>{{ item.totalMinutes }}</td>
                <td>
                  <button
                    class="btn btn-circle btn-sm btn-outline btn-danger"
                    @click="askToRemove(item)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-list" v-show="resultList.list.length === 0 && !this.formControl.listBusy">
            <h2>Listagem vazia</h2>
            <i class="fa fa-inbox icon-empty"></i>
          </div>
          <div class="busy-list" v-show="this.formControl.listBusy">
            <spinner />
          </div>
        </div>
      </div>
    </div>
    <remove-modal
      :show="formControl.isModalVisible"
      @close-modal="modalIsVisible(false)"
      @confirm="removeRegister">
      ok
    </remove-modal>
  </section>
</template>

<script>
  import {mask} from 'vue-the-mask'
  import Spinner from '../../components/Spinner';
  import RemoveModal from '../../components/remove-modal/RemoveModal'

  export default {
    name: 'OutdatedRegister',
    components: { Spinner, RemoveModal },
    directives: {
      mask,
    },
    data () {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          precision: 2,
          masked: false
        },
        filterForm: {
          startDate: '',
          countPages: 0,
          pageLimit: 10,
          pageSkip: 0
        },
        resultList: {
          list: [],
          totalAmountPaid: 0,
        },
        form: {
          date: '',
          time: '',
          licencePlate: '',
          amountPaid: '2,00',
          totalMinutes: 60,
          parking: null,
          employee: null
        },
        formControl: {
          disabledSubmit: false,
          listBusy: false,
          isModalVisible: false
        },
        itemToRemove: {},
        employeeList: [],
        parkingList: []
      }
    },
    filters: {
      fillDate(value) {
        return new Date(value).toLocaleDateString("pt-BR");
      },
      fillTime(value) {
        return new Date(value).toLocaleTimeString("pt-BR");
      },
      totalToCurrencyBR(value) {
        if (!value) {
         return "-";
        }
        // return (value / 100).toFixed(2).toString().replace('.', ',');
        return (value / 100).toLocaleString("pt-BR", {
            minimumFractionDigits: 2
          });
        }
      },
    mounted () {
      this.listEmployees()
      this.listParkings()
    },
    computed: {
      disableSubimitWHenDate() {
        const splittedDt = this.form.date.split('-')
        if (splittedDt.length !== 3) {
          return true
        }

        const dt = new Date(splittedDt[0], splittedDt[1], splittedDt[2], 12, 0, 0)
        return dt >= new Date(2019, 7, 20, 0, 0, 0)
      }
    },
    methods: {
      async listEmployees() {
        const employeeListFull = await this.$store.dispatch('EMPLOYEE/GetEmployeeList')
        const employeeList = employeeListFull.map(item => ({
          id: item._id,
          userToken: item.userToken,
          fullName: item.fullName
        }));

        this.employeeList = employeeList;
      },
      async listParkings() {
        const parkingListFull = await this.$store.dispatch('PARKING/GetParkList')
        const parkingList = parkingListFull.map(item => ({
          id: item._id,
          parkName: item.parkName
        }));
        this.parkingList = parkingList;
      },
      generateNextTime(beforeTime) {
        const randomTime = Math.ceil(Math.random() * (60000 * 45)) + 30000
        const nextTime = new Date(beforeTime.getTime() + randomTime)

        const hours = ('0' + nextTime.getHours()).toString().slice(-2)
        const minutes = ('0' + nextTime.getMinutes()).toString().slice(-2)
        const seconds = ('0' + nextTime.getSeconds()).toString().slice(-2)

        return `${hours}:${minutes}:${seconds}`
      },
      async registerForm() {
        if (this.disableSubimitWHenDate) {
          this.$toasted.error('Não é permitido gerar com data superior ou igual a 20/07/2019')
          return
        }
        this.formControl.disabledSubmit = true
        const forceTime = new Date(`${this.form.date} ${this.form.time}.000`)
        const amountPaid = Number(this.form.amountPaid.replace(',', ''))
        
        const nextTime = this.generateNextTime(forceTime)

        const headers = {
          userToken: this.form.employee
        }

        const payload = {
          forceTime,
          creditPaid: {
            licencePlate: this.form.licencePlate,
            amountPaid,
            totalMinutes: this.form.totalMinutes
          },
          parkingPlace: {
            parking: this.form.parking,
            licencePlate: this.form.licencePlate,
          }
        }

        try {
          await this.$store.dispatch('VEHICLE/PayParkingTakeout', { headers, payload })
          this.formControl.disabledSubmit = false
          this.$toasted.success('Registro salvo com sucesso')
          this.filterReport()
          this.form.licencePlate = ''
          this.form.time = nextTime
          this.form.amountPaid = '2,00'
          this.form.totalMinutes = '60'
          this.$refs.inputLicencePlate.focus()
          this.$refs.inputLicencePlate.select()
        } catch (error) {
          this.$toasted.error('Registro não pode ser salvo')
          this.formControl.disabledSubmit = false
        }
      },
      generateQuery () {
        const query = {
          ...this.filterForm
        }

        if (this.filterForm.startDate) {
          const dt = this.filterForm.startDate.split('/')
          query.startDate = new Date(`${dt[2]}-${dt[1]}-${dt[0]} 00:00:00`)
          query.endDate = new Date(`${dt[2]}-${dt[1]}-${dt[0]} 23:59:00`)
        }

        return query
      },
      checkDateLimit() {
        if (this.filterForm.startDate) {
          const limitDate = new Date(2019, 6, 20, 12, 0, 0)
          const dt = this.filterForm.startDate.split('/')
          const searchDate = new Date(dt[2], Number(dt[1]) - 1, dt[0], 12, 0, 0)
          if (searchDate < limitDate) {
            return true
          }
        }
        this.$toasted.error('Não foi possível fazer a busca com a data informada')
        return false
      },
      async filterReport(resetList = true) {
        if (!this.checkDateLimit()) {
          return false
        }

        this.formControl.listBusy = true
        this.resultList.totalAmountPaid = 0
        if (resetList) {
          this.filterForm.pageSkip = 0;
        }

        const query = this.generateQuery()
        try {
          const reports = await this.$store.dispatch("REPORTS/ReportCredit", {
            query
          });

          if (!reports.list) {
            this.resultList.list = [];
            return true;
          }
          
          this.filterForm.countPages = reports.count;

          const resultList = reports.list.map(item => {
            const licencePlate = item.vehicle ? item.vehicle.licencePlate.toUpperCase() : ''
            const amountPaid = item.amountPaid
            const totalMinutes = item.totalMinutes
            const settled = item.settled
            const creditId = item._id

            let employeeName = ''
            let startDate = ''

            if (item.settled) {
              employeeName = item.settledEmployee.fullName
              startDate = item.paymentDate
            } else {
              employeeName = item.employee.fullName
              startDate = item.createdAt
            }

            return {
              creditId,
              licencePlate,
              amountPaid,
              totalMinutes,
              employeeName,
              startDate,
              settled
            }
          });

          this.resultList.totalAmountPaid = reports.countTotal.totalPaid;

          this.resultList.list = resultList;
          this.formControl.listBusy = false;
        } catch (error) {
          this.resultList.list = [];
          this.formControl.listBusy = false;
        }
      },
      firstPage() {
        this.filterForm.pageSkip = 0
        this.filterReport(false)
      },
      previousPage() {
        if (this.filterForm.pageSkip === 0) {
          return;
        }
        this.filterForm.pageSkip = this.filterForm.pageSkip - this.filterForm.pageLimit;

        this.filterReport(false);
      },
      nextPage() {
        if (this.filterForm.pageSkip + this.filterForm.pageLimit >= this.filterForm.countPages) {
          return;
        }
        this.filterForm.pageSkip = this.filterForm.pageSkip + this.filterForm.pageLimit;
        this.filterReport(false);
      },
      lastPage() {
        this.filterForm.pageSkip = Math.floor(this.filterForm.countPages / this.filterForm.pageLimit) * this.filterForm.pageLimit
        this.filterReport(false)
      },
      selectFocus(elm) {
        setTimeout(() => {
          this.$refs[elm].select()
        }, 10)
      },
      askToRemove(item) {
        this.itemToRemove = item
        this.modalIsVisible(true)
      },
      async removeRegister() {
        if (!this.itemToRemove) { return }  

        this.formControl.listBusy = true

        try {
          await this.$store.dispatch('VEHICLE/RemoveRetroactiveRegister', this.itemToRemove)
          this.filterReport(false)
          this.$toasted.success('Registro removido com sucesso!')
        } catch (error) {
          this.$toasted.error('Não foi possível excluir o registro')
        } finally {
          this.formControl.listBusy = false
        }
      },
      modalIsVisible(state) {
        this.formControl.isModalVisible = state
      }
    }
  }
</script>